"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";

import { SignInComponent } from "./SignInComponent";

interface SignInModalProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /**
   * Full destination URL (path + search + hash) to redirect to after signin
   * Uses type-safe deep linking (ADR-018)
   * @example "/listing/abc123?ref=email#place-bid"
   */
  destination?: string;
}

export function SignInModal({
  open = true,
  onOpenChange,
  destination,
}: SignInModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <SignInComponent destination={destination} variant="modal" />
      </DialogContent>
    </Dialog>
  );
}
